import { addDays, isFutureRange, safeDifferenceInCalendarDays, startOfDay, isAfter } from 'shared/util/datetime-fns';

import type { Filters } from '../../interfaces';

export const adjustInvalidDates = ({ checkInDate, checkOutDate, ...filters }: Partial<Filters>): Partial<Filters> => {
    if (checkInDate && checkOutDate && !isAfter(checkInDate, checkOutDate)) {
        checkOutDate = addDays(1, checkInDate).getTime();
    }
    if (checkInDate && checkOutDate && !isFutureRange(checkOutDate, checkInDate)) {
        const nights = safeDifferenceInCalendarDays(checkInDate, checkOutDate);
        checkInDate = addDays(1, startOfDay(Date.now())).getTime();
        checkOutDate = addDays(nights, checkInDate).getTime();
    }
    return {
        ...filters,
        checkInDate: checkInDate || null,
        checkOutDate: checkOutDate || null,
    };
};
